export default {
  sections: {
    payment: 'Betaling',
  },
  labels: {
    proceed_to_payment: 'Ga naar betaling via link of scan de QR-code',
  },
  buttons: {
    generate_new_link: 'Nieuwe link genereren',
    copy_link: 'Link kopiëren',
    pay_now: 'Nu betalen',
  },
  toasts: {
    failed_to_create_payment_link: 'Betaallink laden mislukt',
  },
};
